import React from 'react';
import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import WatchlistIcon from 'components/Icons/watchlist';
import { ReactComponent as PrevIcon } from 'assets/img/player-prev-arrow.svg';
import RewindIcon from 'components/Icons/rewind';
import PlayIcon from 'components/Icons/play';
import PauseIcon from 'components/Icons/pause';
import FFIcon from 'components/Icons/ff';
import EPGIcon from 'components/Icons/epg';
import { ReactComponent as NextIcon } from 'assets/img/player-next-arrow.svg';
import SettingsIcon from 'components/Icons/settings';
import { StyledControlButton } from './ControlsStyledComponents';

interface IStyledFavoriteButton {
  isActive?: boolean;
}

export const StyledFavoriteButton = styled(StyledControlButton)<IStyledFavoriteButton>`
  padding: ${scaleSize(41)}px 0 0 0;
  position: absolute;
  left: 0;

  & > svg {
    width: ${scaleSize(48)}px;
    height: ${scaleSize(45)}px;
    & > path {
      fill: ${({ theme, isActive }) => (isActive ? theme.activeColor : theme.defaultColor)};
      stroke: ${({ theme, isActive }) => (isActive ? theme.activeColor : theme.defaultColor)};
    }
  }

  &:focus > svg > path {
    fill: ${({ theme }) => theme.focusedTextColor};
    stroke: ${({ theme }) => theme.focusedTextColor};
  }
`;

export const FavoriteButton = ({ onEnter, disabled, isActive }) => {
  return (
    <StyledFavoriteButton
      id="favorite-button"
      onEnter={!disabled && onEnter}
      isActive={isActive}
      isNotAvailable={disabled}
      focusOnMouseEnter
    >
      <WatchlistIcon />
    </StyledFavoriteButton>
  );
};

export const StyledPrevButton = styled(StyledControlButton)`
  padding: ${scaleSize(38)}px 0 0 0;
  margin-right: ${scaleSize(40)}px;

  & > svg {
    width: ${scaleSize(44)}px;
    height: ${scaleSize(40)}px;
  }
`;

export const PrevButton = ({ onEnter, disabled }) => {
  return (
    <StyledPrevButton
      id="prev-button"
      onEnter={!disabled && onEnter}
      isNotAvailable={disabled}
      focusOnMouseEnter
    >
      <PrevIcon />
    </StyledPrevButton>
  );
};

export const StyledRewindButton = styled(StyledControlButton)`
  padding: ${scaleSize(38)}px 0 0 0;

  & > svg {
    margin-left: -${scaleSize(8)}px;
  }
`;

export const RewindButton = ({ onEnter, disabled }) => {
  return (
    <StyledRewindButton
      id="rewind-button"
      onEnter={!disabled && onEnter}
      isNotAvailable={disabled}
      focusOnMouseEnter
    >
      <RewindIcon />
    </StyledRewindButton>
  );
};

export const StyledPlayButton = styled(StyledControlButton)`
  width: ${scaleSize(140)}px;
  height: ${scaleSize(140)}px;
  margin: -${scaleSize(10)}px ${scaleSize(40)}px 0 ${scaleSize(40)}px;
  padding: ${scaleSize(46)}px 0 0 ${scaleSize(14)}px;

  & > svg {
    width: ${scaleSize(40)}px;
    height: ${scaleSize(48)}px;
  }

  & > .pause {
    width: ${scaleSize(36)}px;
    height: ${scaleSize(48)}px;
    padding: 0;
    margin-left: -${scaleSize(12)}px;
  }

  &:focus > svg > path {
    fill: ${({ theme }) => theme.focusedTextColor};
  }
`;

export const PlayButton = ({ onEnter, id, disabled, isPlaying }) => {
  return (
    <StyledPlayButton
      onEnter={!disabled && onEnter}
      id={id}
      isNotAvailable={disabled}
      focusOnMouseEnter
    >
      {isPlaying ? <PauseIcon /> : <PlayIcon />}
    </StyledPlayButton>
  );
};

export const STyledEPGButton = styled(StyledControlButton)`
  width: ${scaleSize(140)}px;
  height: ${scaleSize(140)}px;
  margin: -${scaleSize(10)}px ${scaleSize(40)}px 0 ${scaleSize(40)}px;

  & > svg {
    width: ${scaleSize(140)}px;
    height: ${scaleSize(140)}px;
  }

  &:focus > svg > path {
    fill: ${({ theme }) => theme.focusedTextColor};
  }
`;
export const EPGButton = ({ onEnter, id, disabled }) => {
  return (
    <STyledEPGButton
      onEnter={!disabled && onEnter}
      id={id}
      isNotAvailable={disabled}
      focusOnMouseEnter
    >
      <EPGIcon />
    </STyledEPGButton>
  );
};

export const StyledFFButton = styled(StyledControlButton)`
  padding: ${scaleSize(38)}px 0 0 ${scaleSize(10)}px;
`;

export const FFButton = ({ onEnter, disabled }) => {
  return (
    <StyledFFButton
      id="ff-button"
      onEnter={!disabled && onEnter}
      isNotAvailable={disabled}
      focusOnMouseEnter
    >
      <FFIcon />
    </StyledFFButton>
  );
};

export const StyledNextButton = styled(StyledControlButton)`
  padding: ${scaleSize(38)}px 0 0 0;
  margin-left: ${scaleSize(40)}px;

  & > svg {
    width: ${scaleSize(44)}px;
    height: ${scaleSize(40)}px;
  }
`;

export const NextButton = ({ onEnter, disabled }) => {
  return (
    <StyledNextButton
      id="next-button"
      onEnter={!disabled && onEnter}
      isNotAvailable={disabled}
      focusOnMouseEnter
    >
      <NextIcon />
    </StyledNextButton>
  );
};

export const StyledSettingsButton = styled(StyledControlButton)`
  padding: ${scaleSize(33)}px 0 0 0;
  position: absolute;
  right: 0;

  &:focus > svg > path {
    fill: ${({ theme }) => theme.focusedTextColor};
  }
`;

export const SettingButton = ({ onEnter, disabled }) => {
  return (
    <StyledSettingsButton
      id="settings-button"
      onEnter={!disabled && onEnter}
      isNotAvailable={disabled}
      focusOnMouseEnter
    >
      <SettingsIcon />
    </StyledSettingsButton>
  );
};
